/* eslint-disable */
export default {
  _bubbles_transition: 'bubbles_transition',
  _click: 'click',
  _Collecting_Money: 'Collecting_Money',
  _letters_enter_from_bottom: 'letters_enter_from_bottom',
  _not_vowel_octopus: 'not_vowel_octopus',
  _octopus_tenticles: 'octopus_tenticles',
  _placing_letter: 'placing_letter',
  _submarine_enter: 'submarine_enter',
  _submarine_spelling_practice_jingle: 'submarine_spelling_practice_jingle',
}